import axios from 'axios';
import {IArticle} from "@/shared/model/article.model";

const baseApiUrl = 'api/admin/article';

export default class ArticleService {
    public retrieve(page: number,itemPerPage: number, searchTerm: string): Promise<any> {
        let url = baseApiUrl;

        const params = new URLSearchParams();

        if (page != null) {
            params.append('page', page.toString());
        }
        if (searchTerm) {
            params.append('email', searchTerm);
        }
        if(itemPerPage) {
            params.append('size', itemPerPage.toString());
        }
        const queryString = params.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public delete(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .delete(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public create(entity: IArticle): Promise<IArticle> {
        return new Promise<IArticle>((resolve, reject) => {
            axios
                .post(`${baseApiUrl}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public update(entity: IArticle): Promise<IArticle> {
        return new Promise<IArticle>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${entity.publicId}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public find(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .get(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
